import type { AppliedFrame } from '../transport/applied-frame';
import type { BaseEnvelope, BasePatchOp } from './base-patch';
import { fromBaseRecord } from './from-base-context';
import { compileEncounterLinkRow } from './inventory-encounter-links';
import { readItemField } from './item-field-reader';

const upper = (value: unknown): string => String(value ?? '').toUpperCase();

/** Saved link columns change their held anchors, never the inventory subtree. */
export function savedInventoryLinkFrame(envelope: BaseEnvelope, ops: readonly BasePatchOp[]): AppliedFrame | null {
    if (!ops.length || ops.some(op => op.table !== 'encounter_links') || !Array.isArray(envelope.base.encounter_links)) return null;
    const held = envelope.base.encounter_links.filter(fromBaseRecord);
    const rows: AppliedFrame['rows'][number][] = [], deletes: AppliedFrame['deletes'][number][] = [];
    for (const op of ops) {
        const prior = held.find(row => upper(readItemField(row, 'encounter_link_id')) === upper(op.row_id));
        if (op.op === 'delete') { deletes.push({ table: op.table, row_id: op.row_id }); continue; }
        const saved = { ...prior, ...op.cols, encounter_link_id: op.row_id };
        if (!readItemField(saved, 'encounter_link_from') || !readItemField(saved, 'encounter_link_to')) return null;
        rows.push({ table: op.table, row_id: op.row_id, row: compileEncounterLinkRow(saved) as Record<string, unknown>, base: saved });
    }
    return { kind: 'applied', operation_id: `saved-inventory-links:${envelope.entity}:${envelope.entity_id}:${ops[0]!.base_rev}`,
        encounter_id: envelope.entity_id, actor_id: '', rev: 0, member_revs: {}, computed: {}, new_entities: [], rows, deletes };
}
